import { api } from '../api'

export const getAgentReferralCodes = async () => {
  return await api.v1.agentGetReferralCodes()
}

export default {
  getAgentReferralCodes,
}
